import React, { Component } from "react";
import Widget from "../mpa-widget-interface/widget";
class WidgetRow extends Component {
  state = {};

  /* Depending on certain characteristics extracted previously, spawn abstract Widget objects for each Widget. */
  render() {
    const { identifier, meta, classes, socket, weight } = this.props;
    return (
      <div
        id={identifier}
        key={identifier}
        className={classes}
        style={{ flex: weight }}
      >
        {meta.map(m => (
          <Widget meta={m} socket={socket} key={m.widget.name}></Widget>
        ))}
      </div>
    );
  }
}

export default WidgetRow;
